import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ILotMappedItem } from '@app/logic/lots';
import { CbDisplayValueModule } from '@app/shared/components/display-value/display-value.module';
import { LOT_TYPE_ENUM } from '@classictechsolutions/hubapi-transpiled-enums';
import { CbInfoMessageModule, CbTableModule } from 'cb-hub-lib';
import { IDocAssignmentRow, INewLotSummary } from '../lot-migrator.models';

@Component({
    selector: 'cb-lot-migrator-review',
    standalone: true,
    imports: [CbDisplayValueModule, CbTableModule, CbInfoMessageModule],
    templateUrl: './lot-migrator-review.component.html',
    styleUrls: ['./lot-migrator-review.component.scss']
})
export class LotMigratorReviewComponent implements OnChanges {
    @Input() public cancelledLots: ILotMappedItem[] = [];
    @Input() public newLotSummaries: INewLotSummary[] = [];
    @Input() public docAssignments: IDocAssignmentRow[] = [];
    public readonly LOT_TYPE_ENUM = LOT_TYPE_ENUM;
    public readonly cancelledLotsColumns = ['Lot #', 'Lot Type', 'Job #', 'Address'];
    public readonly newLotsColumns = ['Lot #', 'Lot Type'];
    public readonly documentMigrationColumns = ['Document', 'Type', 'From Lot #', 'From Job #'];
    public assignmentGroups: IDocAssignmentGroup[] = [];

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['docAssignments']) {
            this.assignmentGroups = this.buildAssignmentGroups(this.docAssignments);
        }
    }

    private buildAssignmentGroups(assignments: IDocAssignmentRow[]): IDocAssignmentGroup[] {
        const grouped = new Map<number, IDocAssignmentRow[]>();

        for (const assignment of assignments) {
            const destinationLotNumber = Number(assignment.destinationLotNumber);
            if (!Number.isFinite(destinationLotNumber)) {
                continue;
            }

            const existingGroup = grouped.get(destinationLotNumber);
            if (existingGroup) {
                existingGroup.push(assignment);
                continue;
            }

            grouped.set(destinationLotNumber, [assignment]);
        }

        return Array.from(grouped.entries()).map(([destinationLotNumber, groupedAssignments]) => ({
            destinationLotNumber,
            assignments: groupedAssignments
        }));
    }
}

interface IDocAssignmentGroup {
    destinationLotNumber: number;
    assignments: IDocAssignmentRow[];
}
